import DiscountCouponForm from '../../features/commonfile/DiscountCouponForm'

const ZonalCoordinatorCouponCode = () => {
    return (
        <DiscountCouponForm />
    )
}

export default ZonalCoordinatorCouponCode